module.exports = __webpack_public_path__ + "img/promo-bg.f74c3b0.jpg";